import React from "react";
import Container from "@material-ui/core/Container";
import ContactList from "./ContactList";
import ContactGroupList from "./ContactGroupList";
import PublicContactList from "./PublicContactList";
import AuthService from "../../services/auth.service";
import {useDashboardStyles} from "../settings/dashboardStyles";

export default function Contact() {
    const classes = useDashboardStyles();
    const currentUser = AuthService.getCurrentUser();
    const isAdmin = Boolean(currentUser && Array.isArray(currentUser.roles) && currentUser.roles.includes("ROLE_ADMIN"));

    return (
        <Container maxWidth="lg" className={classes.pageContainer}>
            {isAdmin ? (
                <ContactList publicMode/>
            ) : (
                <>
                    <ContactGroupList/>
                    <ContactList/>
                    <PublicContactList/>
                </>
            )}
        </Container>
    );
}
